<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t5">Dedication</span></p>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p class="p0">For all my wonderful fans</p>
<p class="p0">who asked when this book</p>
<p class="p0">would be in print and</p>
<p class="p0">for Elizabeth who made it a reality.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?dfb63f64